// A small, consistent icon set drawn inline.
//
// Hand-drawn rather than pulled from a library so every glyph shares one
// grid, one stroke weight and one cap style — the mixed Unicode symbols this
// replaces were each from a different typeface and never lined up. Stroke
// inherits currentColor so icons take the colour of the row they sit in.

const base = {
  width: 17,
  height: 17,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.7,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': 'true',
  focusable: 'false',
};

export const IconDashboard = (p) => (
  <svg {...base} {...p}>
    <rect x="3" y="3" width="7.5" height="9" rx="2" />
    <rect x="13.5" y="3" width="7.5" height="5.5" rx="2" />
    <rect x="3" y="15" width="7.5" height="6" rx="2" />
    <rect x="13.5" y="11.5" width="7.5" height="9.5" rx="2" />
  </svg>
);

export const IconFrontDesk = (p) => (
  <svg {...base} {...p}>
    <path d="M3 20v-1.5A3.5 3.5 0 0 1 6.5 15h5A3.5 3.5 0 0 1 15 18.5V20" />
    <circle cx="9" cy="8" r="3.4" />
    <path d="M17.5 11.5h3.2M19.1 9.9v3.2" />
  </svg>
);

export const IconSchedule = (p) => (
  <svg {...base} {...p}>
    <rect x="3" y="4.8" width="18" height="16.2" rx="3" />
    <path d="M3 9.6h18M8 3v3.6M16 3v3.6" />
    <path d="M7.6 14h2.2M14.2 14h2.2M7.6 17.6h2.2M14.2 17.6h2.2" />
  </svg>
);

export const IconMembers = (p) => (
  <svg {...base} {...p}>
    <circle cx="9" cy="8" r="3.3" />
    <path d="M2.8 20v-1.3A3.7 3.7 0 0 1 6.5 15h5a3.7 3.7 0 0 1 3.7 3.7V20" />
    <path d="M16.4 5.2a3.3 3.3 0 0 1 0 6.1M18.2 15.2a3.7 3.7 0 0 1 3 3.5V20" />
  </svg>
);

export const IconPlans = (p) => (
  <svg {...base} {...p}>
    <rect x="2.6" y="5.4" width="18.8" height="13.2" rx="3" />
    <path d="M2.6 10.2h18.8" />
    <path d="M6.6 14.6h4" />
  </svg>
);

export const IconSettings = (p) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="3.2" />
    <path d="M19.4 14.5a1.7 1.7 0 0 0 .34 1.87l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.7 1.7 0 0 0-1.87-.34 1.7 1.7 0 0 0-1.03 1.56V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.11-1.56 1.7 1.7 0 0 0-1.87.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.7 1.7 0 0 0 .34-1.87 1.7 1.7 0 0 0-1.56-1.03H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.56-1.11 1.7 1.7 0 0 0-.34-1.87l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.7 1.7 0 0 0 1.87.34h.08A1.7 1.7 0 0 0 10.13 3.1V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1.03 1.56 1.7 1.7 0 0 0 1.87-.34l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.7 1.7 0 0 0-.34 1.87v.08a1.7 1.7 0 0 0 1.56 1.03H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1.03z" />
  </svg>
);

export const IconBilling = (p) => (
  <svg {...base} {...p}>
    <path d="M5 3.6h14v17l-2.3-1.6-2.3 1.6-2.4-1.6L9.6 20.6 7.3 19 5 20.6z" />
    <path d="M9 8.6h6M9 12.4h6" />
  </svg>
);
